import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../../../../types/store';
import { PapiUser } from '@wix/da-papi-types';
import { requestLeaveGroup } from '@wix/da-shared-react/pkg/redux/groups/actions';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import {
  canPerformPageAction,
  getIsGroupMember,
  getIsGroupFounder,
} from '../../../../../../../selectors/groups';
import { PagePriv } from '../../../../../../../../types/pagePrivileges';
import { getProfileOwnerUser } from '../../../../../../../selectors/users';

import { Props } from './GroupMoreMenu';

export type StateProps = Pick<
  Props,
  | 'profileOwnerUser'
  | 'isGroupMember'
  | 'isGroupFounder'
  | 'canRespondToGroupNotifications'
>;
export type DispatchProps = Pick<
  Props,
  'requestLeaveGroup' | 'showCloseGroupModal'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isGroupMember: getIsGroupMember(state),
  isGroupFounder: getIsGroupFounder(state),
  profileOwnerUser: getProfileOwnerUser(state),
  canRespondToGroupNotifications: canPerformPageAction(
    state,
    PagePriv.CAN_RESPOND_TO_GROUP_NOTIFICATIONS
  ),
});
const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  requestLeaveGroup: (group: PapiUser) => dispatch(requestLeaveGroup(group)),
  showCloseGroupModal: (group: PapiUser) =>
    dispatch(pushModal(ModalType.GROUP_CLOSE, { params: { group } })),
});

export default connect(mapStateToProps, mapDispatchToProps);
